import xtend from 'xtend';
import http from '@nichoth/events/http';

var defaults = {
    showEncoder: true,
    showMediaAssets: true,
    showMediaDetails: true,
    showStreams: true,
    includePrivate: true
};

// take our api fns and return fns that emit events on the app bus
function Api (evs, _api, bus) {
    var api = [
        'assets',
        'categories',
        'encoders',
        'events',
        'facebookLive',
        'keywords',
        'locations',
        'metamarkers',
        'player',
        'technicians',
        'streamTargets',
        'transcript'
    ].reduce(function (acc, domain) {
        acc[domain] = {
            get: http(evs[domain].get, bus, _api[domain].get, {
                type: 'get'
            }),
            edit: http(evs[domain].edit, bus, _api[domain].edit, {
                type: 'edit'
            }),
            add: http(evs[domain].add, bus, _api[domain].add, {
                type: 'add'
            }),
            delete: http(evs[domain].delete, bus,
                _api[domain].delete, { type: 'delete' })
        };
        return acc;
    }, {});

    api.keywords = xtend(api.keywords, {
        get: http(evs.keywords.get, bus, _api.keywords.getKeywordsNonPage, {
            type: 'get',
        }),
    });

    var _get = api.events.get;
    api.events = xtend(api.events, {
        get: function (data) {
            return _get(xtend(defaults, data));
        },
        start: http(evs.events.start, bus, _api.events.start, {
            type: 'start'
        }),
        stop: http(evs.events.stop, bus, _api.events.stop, {
            type: 'stop'
        }),
        publish: http(evs.events.publish, bus, _api.events.publish, {
            type: 'publish'
        }),
        unpublish: http(evs.events.unpublish, bus, _api.events.unpublish, {
            type: 'unpublish'
        })
    });

    api.thumbs = {
        replace: http(evs.thumbs.replace, bus, _api.thumbs.replace, {
            type: 'replace'
        })
    };

    api.assets = xtend(api.assets, {
        miscAssetToEvent: http(evs.assets.miscAssetToEvent, bus,
            _api.assets.miscAssetToEvent, { type: 'miscAssetToEvent' }),

        getMiscAssets: http(evs.assets.getMiscAssets, bus,
            _api.assets.getMiscAssets, { type: 'getMiscAssets' }),
            
        editLink: http(evs.assets.editLink, bus,
            _api.assets.editLink, { type: 'editLink' })
    });

    api.analytics = {
        get: http(evs.analytics.get, bus, _api.analytics.get, {
            type: 'get'
        }),
        getMostWatched: http(evs.analytics.getMostWatched, bus,
            _api.analytics.getMostWatched, { type: 'getMostWatched' }),
        getUpcomingEvents: http(evs.analytics.getUpcomingEvents,
            bus, _api.analytics.getUpcomingEvents, {
                type: 'getUpcomingEvents'
            })
    };

    api.chat = {
        getModerators: http(evs.chat.getModerators, bus,
            _api.chat.getModerators, { type: 'getModerators' }),

        createModerator: http(evs.chat.createModerator, bus,
            _api.chat.createModerator, { type: 'createModerator' }),
            
        updateChatSettings: http(evs.chat.updateChatSettings, bus,
            _api.chat.updateChatSettings, { type: 'updateChatSettings' }),
    
        deleteModerator: http(evs.chat.deleteModerator, bus,
            _api.chat.deleteModerator, { type: 'deleteModerator' }),

        resetPassword: http(evs.chat.resetPassword, bus,
            _api.chat.resetPassword, { type: 'resetPassword' })
    };

    api.streamTargets = [
        'add', 'edit', 'delete',
        'getAltProviders',
        'getAltDestinations'
    ].reduce(function (acc, k) {
        acc[k] = http(evs.streamTargets[k], bus, _api.streamTargets[k], {
            type: k
        });
        return acc;
    }, {});

    api.transcript = ['getTranscriptInfo', 'setUseAsCaptions',
        'setUseText', 'resubmit', 'create', 'delete']
        .reduce(function (acc, k) {
            acc[k] = http(evs.transcript[k], bus, _api.transcript[k], {
                type: k
            });
            return acc;
        }, {});

    api.restrictedDomains = ['add', 'delete']
        .reduce(function (acc, k) {
            acc[k] = http(evs.restrictedDomains[k], bus, _api.restrictedDomains[k], {
                type: k
            });
            return acc;
        }, {});

    api.audioDescription = ['getProject']
        .reduce(function (acc, k) {
            acc[k] = http(evs.audioDescription[k], bus, _api.audioDescription[k], {
                type: k
            });
            return acc;
        }, {});

    return api;
}

export default Api;
